import React, { useCallback } from 'react'
import {
  ModulePanel,
  ModuleHeader,
  ModuleBody,
  ModuleFooter
} from 'containers/purchase/modules/module_panel'
import CustomFieldsForm from 'containers/purchase/modules/custom_fields_module/custom_fields_form'
import { useTranslation } from 'react-i18next'
import { get } from 'lodash'

const CustomFieldsModule = (props) => {
  const { config, machine, status, resSize } = props
  const { i18n } = useTranslation()
  const [current, send] = machine
  const event = current.context.event

  const eventCustomFields = (customFields) => {
    if (!event) return customFields

    const eventCustomFieldIds = get(
      config,
      `external_api_config.event_custom_fields.${event.id}`
    )
    if (!eventCustomFieldIds) return customFields

    return customFields.filter((customField) =>
      eventCustomFieldIds.some((id) => id === customField.id)
    )
  }

  const customFields = eventCustomFields(current.context.customFields)

  const capitalize = (s) =>
    s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : ''
  const moduleTitle = capitalize(config.product.custom_field_block)

  const setForm = useCallback((form) => {
    send({
      type: 'FAREHARBOR_FORM_CHANGE',
      form
    })
  }, [send])

  return (
    <ModulePanel>
      <ModuleHeader
        status={status}
        onClick={() =>
          status === 'completed' ? send('REOPEN_CUSTOMFIELDSSTEP') : null
        }
      >
        <span>
          <i className="fa fa-question-circle me-2" aria-hidden="true"></i>
          {moduleTitle}
        </span>
      </ModuleHeader>
      <ModuleBody status={status}>
        <CustomFieldsForm
          customFields={customFields}
          setForm={setForm}
          machine={machine}
          resSize={resSize}
          active={status === 'active'}
        />
      </ModuleBody>
      <ModuleFooter {...props} />
    </ModulePanel>
  )
}

export default CustomFieldsModule
